export const API_VERSION_UPDATE_MESSAGE =
  "A new version is available. Please update to the latest version to enjoy using ROSI giving.";

export const isApiVersionBlocked = (error = {}) => {
  const status = error?.response?.status ?? error?.statusCode;
  const message = error?.response?.data?.message ?? error?.message;

  return Number(status) === 403 && message === API_VERSION_UPDATE_MESSAGE;
};

export const notifyIfApiVersionBlocked = (error, notify) => {
  if (!isApiVersionBlocked(error)) {
    return false;
  }

  const message = error?.response?.data?.message ?? error?.message;
  if (message && typeof notify === "function") {
    notify(message);
  }

  return true;
};
